import {
  IonButton,
  IonRow,
  IonCol,
} from "@ionic/react";

function BannerTourendata(props) {
  return (
    <>
        <IonRow>
            <IonCol
            className="touren__background__image "
            size="12"
            size-md="6"
            style={{
                background: `url('${props.tourenImageUrl}') no-repeat center`,
            }}
            ></IonCol>
            <IonCol
            size="12"
            size-md="6"
            className="ion-padding-start ion-padding-end "
            >
            <h6>Wohnmobiltouren und Reiseziele</h6>
            <h3>{props.tourenName}</h3>
            <p>{props.tourenExcerpt}</p>
            <br />
            <IonButton
                color="secondary"
                shape="round"
                href={props.tourenLink}
            >
                Mehr erfahren
            </IonButton>{" "}
            </IonCol>
        </IonRow>
    </>
  );
}

export default BannerTourendata;